import PropTypes from "prop-types";
import React from 'react'
import Toggle from './Toggle'

const SwitchSection = (props) => {
    const {
        name,
        goToFunction,
        setDefaultValues,
        removeDefaultValues,
        retryCheck
    } = props

    return (
        <div>
            <div
                className="nip-home-interaction-env-left-back"
                data-testid="goToFunction"
                onClick={() => goToFunction()}
            >
                <p>{"<"}</p> &nbsp;
                    <span>Back</span>
            </div>{" "}
            <div className="title">{name}</div>
            <div className="details">
                Run tests, requests and responses, make API Calls and
                perform other related activities.
                  </div>
            <div className="set-default-box">
                <span className="set-default-box-word">
                    Use default figure for all entries
                    </span>
                <div className="set-default-box-icon">
                    <Toggle
                        setDefaultValues={() => setDefaultValues()}
                        removeDefaultValues={() => removeDefaultValues()}
                        retryCheck={retryCheck}
                    />
                </div>
            </div>
        </div>
    )
}

SwitchSection.propTypes = {
    goToFunction: PropTypes.func,
    name: PropTypes.any,
    removeDefaultValues: PropTypes.func,
    retryCheck: PropTypes.any,
    setDefaultValues: PropTypes.func
}

export default SwitchSection;